import React from 'react';
import { SlideContainer } from './SlideContainer';
import slideTextoObjetoImg from '../assets/SlideTextoObjeto2.jpg';
import { ISlidePropostaData } from '../interface';

export interface SlideObjetoProps {
  data?: ISlidePropostaData;
  scale?: number;
}

const DEFAULT_OBJETO = (planoNome: string, possuiTela: boolean, tipoTela?: string | null) => {
  const dispositivoTexto = possuiTela 
    ? (tipoTela === 'totem' 
        ? ' Além destas funcionalidades, a licença acompanha um Totem Interativo de 32 polegadas com suporte em comodato,' 
        : tipoTela === 'tela85'
        ? ' Além destas funcionalidades, a licença acompanha uma Tela Interativa de 85 polegadas em comodato,'
        : ' Além destas funcionalidades, a licença acompanha uma Tela Interativa de 75 polegadas em comodato,')
    : '';

  return `Contratação de serviço especializado para o fornecimento do aplicativo GovFácil – ${planoNome}. Este aplicativo é projetado para simplificar e otimizar o controle da gestão pública municipal, oferecendo funcionalidades como o monitoramento de certidões e obrigações a nível estadual e federal (CAUC), gestão de receitas e arrecadações, análise de demonstrativos constitucionais, acompanhamento de índices e investimentos em educação, Fundeb, saúde, folha de pagamento, programas e convênios federais, análise fiscal preliminar, controle do fluxo de caixa, dados sobre abertura e fechamento de empresas, comparação de saldo de empregos entre municípios, registros de emplacamento de veículos, monitoramento de publicações jurídicas dos principais tribunais, avaliação do investimento sobre a RCL, acesso a informações do IBGE, comparações e rankings entre municípios baseados em índices e investimentos principais, entre outras informações vitais para a eficiência da administração municipal.${dispositivoTexto} conta também com os recursos de notificações de pendências via WhatsApp, aviso de vencimento de certidões, relatório de cada módulo do aplicativo, Agenda de compromissos, acompanhamento do andamento de Tarefas, possibilidade de Integrações com outros sistemas, possibilidade de gestão do Plano de Governo com a inclusão das ações de cada secretaria municipal e o novo módulo de Saldo de Contas que permite o acesso rápido e confiável às informações financeiras do município, permitindo uma tomada de decisão mais estratégica, transparente e alinhada com a responsabilidade fiscal.`;
};

export const SlideObjeto: React.FC<SlideObjetoProps> = ({ data, scale = 1 }) => {
  const planoNome = data?.plano_nome || 'Licença Intermediária';
  const possuiTela = data?.possui_tela ?? true;
  const tipoTela = data?.tipo_tela;
  const textoExibicao = data?.texto_objeto || DEFAULT_OBJETO(planoNome, possuiTela, tipoTela);

  return (
    <SlideContainer 
      showFooterLogo={false} 
      showWaves={false} 
      noPadding={true}
      backgroundImage={slideTextoObjetoImg}
      scale={scale}
      data={data}
    >
      <div
        style={{
          position: 'absolute',
          top: '17%',
          left: '4.5%',
          width: '61%',
          color: '#ffffff',
          fontSize: 22.5,
          fontWeight: 600,
          lineHeight: 1.48,
          textAlign: 'justify',
          letterSpacing: -0.1,
        }}
      >
        {textoExibicao}
      </div>
    </SlideContainer>
  );
};